import '../css/module_theupdates.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';

import {
    persUrl,
    sentryAPIErrorV2,
    protectedApiCall,
    funnelUpdateWhenAvailable,
    attachTryPremiumSubscribe,
} from './module_common'


import {
    configPlayer, 
    pageSetup, 
    getPlayerRef,
    updateUiPlayerSlider,
} from './module_player_new';

import './module_common_actions';

import {configTuCard} from './module_tu_card';

import { initNavbar } from './module_header';
import { initCardLazyLoad } from './module_lazyload';

const completed = 2;

let waitId = null

const cardsContainer = $(".theupdates-cards-wrap")

const doRemoteUpdateReadProgress = function (status) {
    const readStatus = thReadProgressMax
    if (readStatus == completed) return
    if (thPREP) {
        const ep = persUrl(thPREP);
        if (!ep) return;
        const d = {"theupdate_id": thCode, "status": status};
        protectedApiCall(
            'POST', 
            ep,
            d,
            function (data) {
            },
            function (err) {
                const contextData = {
                    apicalldata: {
                        function: "doRemoteUpdateReadProgress",
                        url: ep,
                        method: 'POST',
                        data: JSON.stringify(d),
                        status: err.status,
                        response: err.responseJSON,
                    }
                }
                const error = new Error('protectedApiCall error')
                error.name = 'doRemoteUpdateReadProgress fail'
                sentryAPIErrorV2(error, contextData)
            },
            true);
    }
};

function showWaitBlock(){
    // show spinner only after spinnerTimeout ms
    const spinnerTimeout = 300

    waitId = setTimeout(()=>{
        $('.showmore-wrap').addClass("wait-search")
    }, spinnerTimeout)
}

function hideWaitBlock(){
    clearTimeout(waitId)
    $('.showmore-wrap').removeClass("wait-search")
}

function apiTheUpdateSearch(limit, offset){
    limit = limit || defaultLimit;
    offset = offset || 0;
    showWaitBlock();
    $.ajax({
        method: "POST",
        url: searchEndPoint,
        data: {
            limit: limit,
            offset: offset
        },
        dataType: 'json',
        success: function(data){
            cardsContainer.append(data['html'])
            initCardLazyLoad()
            configTuCard()
        },
        error: function(err){
        }
    }).done(function() {
        hideWaitBlock()
    });

}

function attachShowNextPageListener(){
    $("#showmorebtn").on('click', function(){
        const elements = cardsContainer.find(".tu-card-container");
        apiTheUpdateSearch(itemsPerPage, elements.length);
    })
}

function attachAudioDurationUpdate(){
    const playerRef = getPlayerRef()
    if (playerRef.totalTime.length == 0 ) return
    playerRef.totalTime[0].addEventListener(playerRef.totalTimeEvent, function(e){
        let minutes = Math.floor(e.duration / 60);
        const seconds = e.duration - minutes * 60;
        if (seconds > 10) minutes++
        $(".tu-duration").html(minutes)
        const current = $(".player-4books").data('current')
        updateUiPlayerSlider(current, e.duration)
    })
}

$(function () {
    initFirebaseApp()
    manageLogin()

    attachTryPremiumSubscribe()
    
    doLast()
    initNavbar()

    if(isDetail){
        if (gotAudio){
            configPlayer()
            attachAudioDurationUpdate()
            pageSetup()
        }
        doRemoteUpdateReadProgress(completed)
        if (!isPageReloadedAfterLogin){
            funnelUpdateWhenAvailable('news_viewed');
        }
    }else{
        initCardLazyLoad()
        configTuCard()
        attachShowNextPageListener()
        if (!isPageReloadedAfterLogin){
            funnelUpdateWhenAvailable('news_list_viewed');
        }
    }    
    
});